import { jsx as _jsx } from "react/jsx-runtime";
import ButtonBase from '#pplx/frontend/components/buttons/ButtonBase.js';
import classNames from 'classnames';
import { memo, useMemo } from 'react';
/**
 * @deprecated - Prefer `aether/components/Button` whenever possible. Reach out to #web-design-system for help.
 */
const Button = memo(function Button(props) {
    const { variant = 'common', disabled, extraCSS, ...rest } = props;
    const { buttonClass } = useMemo(() => {
        const variantClasses = {
            disabled: 'bg-soft text-secondary',
            primary: 'text-inverse hover:opacity-80 bg-button-bg',
            primaryGhost: 'border border-button-bg/20 bg-button-bg/10 hover:bg-button-bg/20 hover:border-button-bg/30 text-button-bg',
            common: 'bg-soft text-primary md:hover:text-secondary',
            border: 'border border-base text-secondary md:hover:border-base md:hover:text-secondary hover:bg-subtle bg-base',
            inverted: 'bg-inverse text-inverse hover:opacity-80',
            rejecter: 'border border-soft text-negative-primary dark:hover:text-primary hover:bg-negative-soft hover:border-negative-subtle bg-base',
            rejected: 'bg-negative-strong hover:opacity-50 text-white',
            orange: 'bg-warning-strong text-white hover:opacity-50',
            maxGold: 'bg-super-strong dark:text-inverse hover:opacity-80',
        };
        // Select the appropriate class based on disabled state and variant
        const selectedClass = disabled ? variantClasses.disabled : variantClasses[variant];
        return {
            buttonClass: classNames(selectedClass, extraCSS),
        };
    }, [variant, disabled, extraCSS]);
    return _jsx(ButtonBase, { extraCSS: buttonClass, disabled: disabled, variant: variant, ...rest });
});
export default Button;
//# sourceMappingURL=Button.js.map